import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function projectReducer(state = initialState.inventory, action) {
    switch (action.type) {
        case types.GET_PROJECT_INVENTORY_SUCCESS:
            return action.inventory;
        case types.GET_PROJECT_INVENTORY_FAILED:
            return action.error;
        default:
            return state;
    }
}